import React, { useState, useEffect } from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'About', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Work', href: '#work' },
    { name: 'Founder', href: '#founder' },
  ];

  return (
    <nav className={`fixed w-full z-50 transition-all duration-500 ${isScrolled ? 'bg-navy-900/95 backdrop-blur-md py-4 shadow-lg' : 'bg-transparent py-6'}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex justify-between items-center">
        {/* Logo */}
        <a href="#" className="flex flex-col z-50 group">
          <span className={`font-serif text-2xl font-bold tracking-wider transition-colors duration-300 ${isScrolled ? 'text-white' : 'text-white'}`}>
            PAGE1<span className="text-gold-500">NEWS</span>
          </span>
          <span className={`text-[0.6rem] uppercase tracking-[0.2em] transition-colors duration-300 ${isScrolled ? 'text-gray-400' : 'text-gray-300'} group-hover:text-gold-400`}>
             PR & Media
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-10">
          {navLinks.map((link) => (
            <a key={link.name} href={link.href} className={`text-sm tracking-widest uppercase transition-colors duration-300 hover:text-gold-500 ${isScrolled ? 'text-gray-300' : 'text-gray-200'}`}>
              {link.name}
            </a>
          ))}
          <a href="#contact" className="border border-gold-500 text-gold-500 px-6 py-2 text-sm uppercase tracking-widest hover:bg-gold-500 hover:text-navy-900 transition-all duration-300">
            Let's Talk
          </a>
        </div>

        {/* Mobile Toggle */}
        <button 
          className="md:hidden z-50 text-white focus:outline-none"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <SafeIcon icon={isMobileMenuOpen ? FiIcons.FiX : FiIcons.FiMenu} className="text-2xl" />
        </button>

        {/* Mobile Menu */}
        <div className={`fixed inset-0 bg-navy-900 flex flex-col items-center justify-center space-y-8 transition-transform duration-500 ease-in-out md:hidden ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}>
          {navLinks.map((link) => (
            <a 
              key={link.name} 
              href={link.href} 
              onClick={() => setIsMobileMenuOpen(false)}
              className="text-2xl font-serif text-white hover:text-gold-500 transition-colors"
            >
              {link.name}
            </a>
          ))}
          <a 
            href="#contact" 
            onClick={() => setIsMobileMenuOpen(false)}
            className="border border-gold-500 text-gold-500 px-8 py-3 uppercase tracking-widest mt-4"
          >
            Let's Talk
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;